import React, { useState } from "react";
import LoginModal from "../LoginModal/index.js";
import GoogleOneTap from "./GoogleOneTap";
import { useSelector } from "react-redux";
import useAfterLogin from "../../hooks/useAfterLogin";

const Login = ({dir, cid, onMenuClick}) => {
  const [showLoginModal, setShowLoginModal] = useState(false);
  const user = useSelector((state) => state.user.user);
  const afterLogin = useAfterLogin();
  const handleGoogleOneTapLogin = (data) => afterLogin(data, 'GoogleOneTap');

  // feature toggle
  const [isAuthEnabled, setIsAuthEnabled] = useState(true);

  return (
    isAuthEnabled ?
      <>
        <button onClick={() => { if (onMenuClick) onMenuClick(); setShowLoginModal(true); }} type="button" className="btn btn-lg">
          {user ? (
            user.picture ? (
              <img src={user.picture} alt="Profile" className="bi rounded-circle" width="24" height="24" />
            ) : (
              <div className="bi rounded-circle text-white d-flex align-items-center justify-content-center" style={{ backgroundColor: "#87d6e4", width: "24px", height: "24px", fontSize: "20px", marginLeft: "auto", marginRight: "auto" }}>
                {user.name ? user.name.charAt(0).toUpperCase() : user.email.charAt(0).toUpperCase()}
              </div>
            )
          ) : (
            <>
              <GoogleOneTap onLogin={handleGoogleOneTapLogin} cid={cid}></GoogleOneTap>
              <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" style={{ fill: "#87d6e4" }} className="bi bi-person-fill" viewBox="0 0 16 16">
                <path d="M3 14s-1 0-1-1 1-4 6-4 6 3 6 4-1 1-1 1zm5-6a3 3 0 1 0 0-6 3 3 0 0 0 0 6" />
              </svg>
            </>
          )
          }
        </button>
        <LoginModal dir={dir} shouldShow={showLoginModal} setModalVisible={setShowLoginModal} user={user} afterLogin={afterLogin} cid={cid}></LoginModal>
      </>
      :
      <button type="button" className="btn btn-lg">
        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" style={{ fill: "#87d6e4" }} className="bi bi-person-fill" viewBox="0 0 16 16">
          <path d="M3 14s-1 0-1-1 1-4 6-4 6 3 6 4-1 1-1 1zm5-6a3 3 0 1 0 0-6 3 3 0 0 0 0 6" />
        </svg>
      </button>
  );
};

export default Login;
